import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BookingWidget } from '@/components/forms/BookingWidget';
import { CheckCircle2 } from 'lucide-react';

export function CampaignLandingPage() {
  return (
    <main className="bg-ground-alt min-h-screen">
      <Helmet>
        <title>Special Offer | FIVE LENS Enneagram</title>
      </Helmet>
      
      {/* Stripped header just for campaign layout */}
      <header className="py-6 px-6 lg:px-12 bg-white border-b border-ground-deep flex justify-center lg:justify-start">
        <span className="text-xl font-serif font-bold text-ink uppercase tracking-widest">
          FIVE LENS <span className="text-rule-3">Enneagram</span>
        </span>
      </header>

      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div>
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-rule-3 mb-4 block">Limited Availability</span>
            <h1 className="text-4xl lg:text-5xl font-serif text-ink mb-6">Transform Your Leadership Team</h1>
            <p className="text-lg text-ink/80 mb-8 leading-relaxed">
              Book a targeted discovery session to see how the FIVE LENS Enneagram can be tailored to resolve friction and elevate performance in your specific organisational context.
            </p>
            
            <ul className="space-y-4 mb-10">
              {[
                'Identify systemic team dysfunctions',
                'Align social drives with strategic goals',
                'Build emotional resilience in high-stress roles'
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-rule-3 shrink-0 mt-0.5" />
                  <span className="text-ink/80">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white p-2 border border-ground-deep shadow-lg">
            <BookingWidget ctaPosition="campaign_landing_page" />
          </div>

        </div>
      </div>
    </main>
  );
}
